import { render, staticRenderFns } from "./DSArrowRightIcon.vue?vue&type=template&id=6c680992&"
import script from "./DSArrowRightIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports